import React, {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {setCookiesAcceptedByUser} from 'modules/cookies/slice'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'
import {CookieConsentBannerWithStore} from '@vio/shared/src/search/cookies'

const CookieBanner = () => {
  const dispatch = useDispatch()
  const {compliance} = useBrandCapabilities()
  const isHydrated = useIsHydrated()
  const isCookieConsentGivenExternally = Boolean(
    typeof window !== 'undefined' && window.osanoMobileAppIdentifier
  )

  const handleSetCookiesAcceptedByUser = useCallback(
    (acceptedByUser: boolean) => {
      dispatch(setCookiesAcceptedByUser(acceptedByUser))
    },
    []
  )

  if (
    !isHydrated ||
    !compliance.cookieConsent.enabled ||
    isCookieConsentGivenExternally
  ) {
    return null
  }

  return (
    <CookieConsentBannerWithStore onAccept={handleSetCookiesAcceptedByUser} />
  )
}

export default React.memo(CookieBanner)
